import { Collapse, styled } from '@material-ui/core';
import { IconButton, TextButton } from '@ds/react-components';
import { ReactComponent as ArrowUpIcon } from 'assets/icons/ic-arrow-up.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/ic-arrow-down.svg';

export const Container = styled('div')({
  minHeight: 450,
});

export const TitleContainer = styled('div')({
  display: 'flex',
});

export const Title = styled('h3')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '26px',
  lineHeight: '31px',
  marginBottom: '10px',
  padding: 0,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
}));

export const AccountTagsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  '& span': {
    marginRight: 5,
  },
  marginBottom: '40px',
});

export const CopyButtonContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
});

export const CopyButton = styled(IconButton)({
  marginLeft: 3,
});

export const Divider = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.xpl.stoke}`,
  marginBottom: '20px',
}));

export const RowRightTextButton = styled(TextButton)(({ theme }) => ({
  color: theme.palette.xpl.text.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  textAlign: 'right',
}));

const getArrowStyles = (theme) => ({
  width: '8px',
  height: '4px',
  color: theme.palette.xpl.secondary.default,
  marginLeft: '8px',
});

export const ExpandMoreIcon = styled(ArrowDownIcon)(({ theme }) => ({
  ...getArrowStyles(theme),
}));

export const ExpandLessIcon = styled(ArrowUpIcon)(({ theme }) => ({
  ...getArrowStyles(theme),
}));

export const Collapsible = styled(Collapse)(({ theme }) => ({
  borderRadius: '6px',
  backgroundColor: theme.palette.xpl.background,
  padding: '10px 16px 10px 16px',
  marginBottom: '19px',
}));
